export const TOGGLE_PATIENT_MENU = 'TOGGLE_PATIENT_MENU'
export const TOGGLE_DOCTOR_MENU = 'TOGGLE_DOCTOR_MENU'
export const TOGGLE_PRESS_CONFERENCE_MENU = 'TOGGLE_PRESS_CONFERENCE_MENU'
export const TOGGLE_INVITATION_MENU = 'TOGGLE_INVITATION_MENU'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js